import { useCallback } from 'react';
import { ProjectStatus } from '@enums';
import { ButtonActivityIndicator } from '@presentation';
import { useAsyncStateLazy } from '@utils';
import * as api from '$admin/api';
import Button from 'components/Button';
import { ButtonSet } from 'components/Modal/ButtonSet';
import { Header } from 'components/Modal/Header';
import { Modal, ModalProps } from 'components/Modal/Modal';
import { Body } from 'components/Modal/Body';
import styles from './style/Project.RejectMember.css';

type Props = {
  project: Descriptor;
  onConfirm?: (project: Descriptor) => unknown;
} & Pick<ModalProps, 'open' | 'onClose'>;

export function Archive({ project, open, onClose, onConfirm }: Props) {
  const handleConfirm = useCallback(() => {
    return api.updateProjectStatus({
      projectId: project.id,
      statusId: ProjectStatus.Archived,
    })
    .finally(() => onConfirm(project));
  }, [project, onConfirm]);

  const [response, confirm] = useAsyncStateLazy(handleConfirm, [handleConfirm]);

  return (
    <Modal
      onClose={onClose}
      open={open}>
      <Header>{`Are you sure you want to archive the ${project.name} project?`}</Header>
      <Body>If you archive this project, all pending calls and expert requests will be cancelled and the project will be locked for editing.</Body>
      <ButtonSet className={styles.buttonset}>
        <Button
          className={styles.cancel}
          color="destructive"
          onClick={onClose}
          variant="brick">
          Cancel
        </Button>
        <ButtonActivityIndicator
          className={styles.btn}
          color="primary"
          loading={response.loading}
          onClick={confirm}
          variant="brick">
          Archive
        </ButtonActivityIndicator>
      </ButtonSet>
    </Modal>
  );
}

Archive.displayName = 'Modal.Project.Archive';